import { render } from "./editStock.vue?vue&type=template&id=3dd02962&scoped=true"
import script from "./editStock.vue?vue&type=script&lang=js"
export * from "./editStock.vue?vue&type=script&lang=js"

import "./editStock.vue?vue&type=style&index=0&id=3dd02962&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dd02962"

export default script